import { render } from "./ProfileComponent.vue?vue&type=template&id=ad94eb08"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"
script.render = render

export default script